import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Box } from "@material-ui/core";
import { DialogProps } from "../../../hooks/dialog/useDialog";
import ReactDOM from "react-dom";

export default function TrDialog({
  isOpened,
  title,
  message,
  cancelButtonText,
  okButtonText,
  onClose,
  onOkButtonClick,
}: DialogProps) {
  return isOpened
    ? ReactDOM.createPortal(
        <Dialog
          open={isOpened}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <Box p="10px">
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {message}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" color="primary" onClick={onClose}>
                {cancelButtonText}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={onOkButtonClick}
                autoFocus
              >
                {okButtonText}
              </Button>
            </DialogActions>
          </Box>
        </Dialog>,
        document.body
      )
    : null;
}
